import { useQuery } from 'react-query';

import createFetchData from '../utils/createFetchData';
import generateQueryKey from '../utils/generateQueryKey';

export default function useResourceQuery({
  config = {},
  params,
  prefix,
  url,
  defaultValue = {
    meta: {},
    data: []
  }
}) {
  const queryKey = generateQueryKey({ params, prefix, url });

  const query = useQuery({
    queryKey,
    queryFn: () => createFetchData({ url, params }),
    config
  });

  const { data } = query;

  return {
    ...query,
    value: data ? data.data : defaultValue,
    queryKey
  };
}
